import "antd/es/spin/style";
import _Spin from "antd/es/spin";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import "antd/es/space/style";
import _Space from "antd/es/space";
var _excluded = ["value", "text"],
    _excluded2 = ["mode", "valueEnum", "render", "renderFormItem", "request", "fieldProps", "plain", "children", "light", "proFieldKey", "params", "label", "bordered", "id"];
import { useMemo } from 'react';
import React, { useState, useImperativeHandle, useRef, useContext, useCallback, useEffect } from 'react';
import { nanoid, useDeepCompareEffect, useMountMergeState, useDebounceValue } from '@ant-design/pro-utils';
import { useIntl } from '@ant-design/pro-provider';
import LightSelect from './LightSelect';
import SearchSelect from './SearchSelect';
import TableStatus, { ProFieldBadgeColor } from '../Status';
import './index.less';
import useSWR from 'swr';
export var ObjToMap = function ObjToMap(value) {
  if (getType(value) === 'map') {
    return value;
  }

  return new Map(Object.entries(value || {}));
};
/**
 * 转化 text 和 valueEnum 通过 type 来添加 Status
 *
 * @param text
 * @param valueEnum
 * @param pure 纯净模式，不增加 status
 */

export var proFieldParsingText = function proFieldParsingText(text, valueEnumParams) {
  if (Array.isArray(text)) {
    return /*#__PURE__*/React.createElement(_Space, null, text.map(function (value) {
      return (
        /*#__PURE__*/
        // @ts-ignore
        React.createElement(React.Fragment, {
          key: (value === null || value === void 0 ? void 0 : value.value) || value
        }, proFieldParsingText(value, valueEnumParams))
      );
    }));
  }

  var valueEnum = ObjToMap(valueEnumParams);

  if (!valueEnum.has(text) && !valueEnum.has("".concat(text))) {
    // @ts-ignore
    return (text === null || text === void 0 ? void 0 : text.label) || text;
  }

  var domText = valueEnum.get(text) || valueEnum.get("".concat(text));

  if (!domText) {
    // @ts-ignore
    return (text === null || text === void 0 ? void 0 : text.label) || text;
  }

  var status = domText.status,
      color = domText.color;
  var Status = TableStatus[status || 'Init']; // 如果类型存在优先使用类型

  if (Status) {
    return /*#__PURE__*/React.createElement(Status, null, domText.text);
  } // 如果不存在使用颜色


  if (color) {
    return /*#__PURE__*/React.createElement(ProFieldBadgeColor, {
      color: color
    }, domText.text);
  } // 什么都没有使用 text


  return domText.text || domText;
};

var Highlight = function Highlight(_ref) {
  var label = _ref.label,
      words = _ref.words;

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var lightCls = getPrefixCls('pro-select-item-option-content-light');
  var optionCls = getPrefixCls('pro-select-item-option-content');
  var matchKeywordsRE = new RegExp(words.map(function (word) {
    return word.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  }).join('|'), 'gi');
  var matchText = label;
  var elements = [];

  while (matchText.length) {
    var match = matchKeywordsRE.exec(matchText);

    if (!match) {
      elements.push(matchText);
      break;
    }

    var start = match.index;
    var matchLength = match[0].length + start;
    elements.push(matchText.slice(0, start), /*#__PURE__*/React.createElement('span', {
      className: lightCls
    }, matchText.slice(start, matchLength)));
    matchText = matchText.slice(matchLength);
  }

  return /*#__PURE__*/React.createElement.apply(React, ['div', {
    className: optionCls
  }].concat(elements));
};
/**
 * 获取类型的 type
 *
 * @param obj
 */


function getType(obj) {
  // @ts-ignore
  var type = Object.prototype.toString.call(obj).match(/^\[object (.*)\]$/)[1].toLowerCase();
  if (type === 'string' && _typeof(obj) === 'object') return 'object'; // Let "new String('')" return 'object'

  if (obj === null) return 'null'; // PhantomJS has type "DOMWindow" for null

  if (obj === undefined) return 'undefined'; // PhantomJS has type "DOMWindow" for undefined

  return type;
}
/**
 * 递归筛选 item
 *
 * @param item
 * @param keyWords
 * @returns
 */


function filerByItem(item, keyWords) {
  var _item$label, _item$value;

  if (!keyWords) return true;

  if ((item === null || item === void 0 ? void 0 : (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.toString().toLowerCase().includes(keyWords.toLowerCase())) || (item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.toString().toLowerCase().includes(keyWords.toLowerCase()))) {
    return true;
  }

  if (item.optionType === 'optGroup' && (item.children || item.options)) {
    var findItem = [].concat(_toConsumableArray(item.children || []), [item.options || []]).find(function (mapItem) {
      return filerByItem(mapItem, keyWords);
    });
    if (findItem) return true;
  }

  return false;
}
/**
 * 把 value 的枚举转化为数组
 *
 * @param valueEnum
 */


export var proFieldParsingValueEnumToArray = function proFieldParsingValueEnumToArray(valueEnumParams) {
  var enumArray = [];
  var valueEnum = ObjToMap(valueEnumParams);
  valueEnum.forEach(function (_, key) {
    var value = valueEnum.get(key) || valueEnum.get("".concat(key));

    if (!value) {
      return;
    }

    if (_typeof(value) === 'object' && (value === null || value === void 0 ? void 0 : value.text)) {
      enumArray.push({
        text: value === null || value === void 0 ? void 0 : value.text,
        value: key,
        label: value === null || value === void 0 ? void 0 : value.text,
        disabled: value.disabled
      });
      return;
    }

    enumArray.push({
      text: value,
      value: key
    });
  });
  return enumArray;
};
export var useFieldFetchData = function useFieldFetchData(props) {
  var _props$fieldProps, _ref3, _props$debounceTime, _props$fieldProps3, _props$fieldProps6;

  var cacheForSwr = props.cacheForSwr;

  var _useState = useState(props.defaultKeyWords),
      _useState2 = _slicedToArray(_useState, 2),
      keyWords = _useState2[0],
      setKeyWords = _useState2[1];
  /** Key 是用来缓存请求的，如果不在是有问题 */


  var _useState3 = useState(function () {
    if (props.proFieldKey) {
      return props.proFieldKey.toString();
    }

    if (props.request) {
      return nanoid();
    }

    return 'no-fetch';
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      cacheKey = _useState4[0];

  var proFieldKeyRef = useRef(cacheKey);
  var getOptionsFormValueEnum = useCallback(function (coverValueEnum) {
    return proFieldParsingValueEnumToArray(ObjToMap(coverValueEnum)).map(function (_ref2) {
      var value = _ref2.value,
          text = _ref2.text,
          rest = _objectWithoutProperties(_ref2, _excluded);

      return _objectSpread({
        label: text,
        value: value,
        key: value
      }, rest);
    });
  }, []);

  var _useMountMergeState = useMountMergeState(function () {
    if (props.valueEnum) {
      return getOptionsFormValueEnum(props.valueEnum);
    }

    return [];
  }, {
    value: (_props$fieldProps = props.fieldProps) === null || _props$fieldProps === void 0 ? void 0 : _props$fieldProps.options
  }),
      _useMountMergeState2 = _slicedToArray(_useMountMergeState, 2),
      options = _useMountMergeState2[0],
      setOptions = _useMountMergeState2[1];

  useDeepCompareEffect(function () {
    var _props$fieldProps2;

    // 优先使用 fieldProps?.options
    if (!props.valueEnum || ((_props$fieldProps2 = props.fieldProps) === null || _props$fieldProps2 === void 0 ? void 0 : _props$fieldProps2.options)) return;
    setOptions(getOptionsFormValueEnum(props.valueEnum));
  }, [props.valueEnum]);
  var swrKey = useDebounceValue([proFieldKeyRef.current, props.params, keyWords], (_ref3 = (_props$debounceTime = props.debounceTime) !== null && _props$debounceTime !== void 0 ? _props$debounceTime : props === null || props === void 0 ? void 0 : (_props$fieldProps3 = props.fieldProps) === null || _props$fieldProps3 === void 0 ? void 0 : _props$fieldProps3.debounceTime) !== null && _ref3 !== void 0 ? _ref3 : 0, [props.params, keyWords]);

  var _useSWR = useSWR(function () {
    if (!props.request) {
      return null;
    }

    return swrKey;
  }, function (_, params, kw) {
    return props.request(_objectSpread(_objectSpread({}, params), {}, {
      keyWords: kw
    }), props);
  }, {
    revalidateIfStale: !cacheForSwr,
    // 打开 cacheForSwr 的时候才应该支持两个功能
    revalidateOnReconnect: cacheForSwr,
    shouldRetryOnError: false,
    // @todo 这个功能感觉应该搞个API出来
    revalidateOnFocus: false
  }),
      data = _useSWR.data,
      setLocaleData = _useSWR.mutate,
      isValidating = _useSWR.isValidating;

  var resOptions = useMemo(function () {
    var _props$fieldProps4, _props$fieldProps5;

    var opt = options === null || options === void 0 ? void 0 : options.map(function (item) {
      if (typeof item === 'string') {
        return {
          label: item,
          value: item
        };
      }

      if ((item === null || item === void 0 ? void 0 : item.optionType) === 'optGroup' && (item.children || item.options)) {
        var childrenOptions = [].concat(_toConsumableArray(item.children || []), _toConsumableArray(item.options || [])).filter(function (mapItem) {
          return filerByItem(mapItem, keyWords);
        });
        return _objectSpread(_objectSpread({}, item), {}, {
          children: childrenOptions,
          options: childrenOptions
        });
      }

      return item;
    }); // filterOption 为 true 时 filter数据, filterOption 默认为true

    if (((_props$fieldProps4 = props.fieldProps) === null || _props$fieldProps4 === void 0 ? void 0 : _props$fieldProps4.filterOption) === true || ((_props$fieldProps5 = props.fieldProps) === null || _props$fieldProps5 === void 0 ? void 0 : _props$fieldProps5.filterOption) === undefined) {
      return opt === null || opt === void 0 ? void 0 : opt.filter(function (item) {
        if (!item) return false;
        if (!keyWords) return true;
        return filerByItem(item, keyWords);
      });
    }

    return opt;
  }, [options, keyWords, (_props$fieldProps6 = props.fieldProps) === null || _props$fieldProps6 === void 0 ? void 0 : _props$fieldProps6.filterOption]);
  return [isValidating, props.request ? data : resOptions, function (fetchKeyWords) {
    setKeyWords(fetchKeyWords);
  }, function () {
    setKeyWords(undefined);
    setLocaleData([], false);
  }];
};
/**
 * 可以根据 valueEnum 来进行类型的设置
 *
 * @param
 */

var FieldSelect = function FieldSelect(props, ref) {
  var mode = props.mode,
      valueEnum = props.valueEnum,
      render = props.render,
      renderFormItem = props.renderFormItem,
      request = props.request,
      fieldProps = props.fieldProps,
      plain = props.plain,
      children = props.children,
      light = props.light,
      proFieldKey = props.proFieldKey,
      params = props.params,
      label = props.label,
      bordered = props.bordered,
      id = props.id,
      rest = _objectWithoutProperties(props, _excluded2);

  var inputRef = useRef();
  var intl = useIntl();
  var keyWordsRef = useRef('');
  var fieldNames = fieldProps.fieldNames;
  useEffect(function () {
    keyWordsRef.current = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.searchValue;
  }, [fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.searchValue]);

  var _useFieldFetchData = useFieldFetchData(props),
      _useFieldFetchData2 = _slicedToArray(_useFieldFetchData, 4),
      loading = _useFieldFetchData2[0],
      options = _useFieldFetchData2[1],
      _fetchData = _useFieldFetchData2[2],
      resetData = _useFieldFetchData2[3];

  var size = useContext(_ConfigProvider.SizeContext);
  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, inputRef.current || {}), {}, {
      fetchData: function fetchData() {
        return _fetchData();
      }
    });
  });
  var optionsValueEnum = useMemo(function () {
    if (mode !== 'read') return;

    var _ref4 = fieldNames || {},
        _ref4$label = _ref4.label,
        labelPropsName = _ref4$label === void 0 ? 'label' : _ref4$label,
        _ref4$value = _ref4.value,
        valuePropsName = _ref4$value === void 0 ? 'value' : _ref4$value,
        _ref4$options = _ref4.options,
        optionsPropsName = _ref4$options === void 0 ? 'options' : _ref4$options;

    var valuesMap = new Map();

    var traverseOptions = function traverseOptions(_options) {
      if (!(_options === null || _options === void 0 ? void 0 : _options.length)) {
        return valuesMap;
      }

      var length = _options.length;
      var i = 0;

      while (i < length) {
        var cur = _options[i++];
        valuesMap.set(cur[valuePropsName], cur[labelPropsName]);
        traverseOptions(cur[optionsPropsName]);
      }

      return valuesMap;
    };

    return traverseOptions(options);
  }, [fieldNames, mode, options]);

  if (mode === 'read') {
    var dom = /*#__PURE__*/React.createElement(React.Fragment, null, proFieldParsingText(rest.text, ObjToMap(valueEnum || optionsValueEnum)));

    if (render) {
      return render(rest.text, _objectSpread({
        mode: mode
      }, fieldProps), dom) || null;
    }

    return dom;
  }

  if (mode === 'edit' || mode === 'update') {
    var renderDom = function renderDom() {
      if (light) {
        return /*#__PURE__*/React.createElement(LightSelect, _extends({
          bordered: bordered,
          id: id,
          loading: loading,
          ref: inputRef,
          allowClear: true,
          size: size,
          options: options,
          label: label,
          placeholder: intl.getMessage('tableForm.selectPlaceholder', '请选择')
        }, fieldProps));
      }

      return /*#__PURE__*/React.createElement(SearchSelect, _extends({
        key: "SearchSelect",
        className: rest.className,
        style: _objectSpread({
          minWidth: 100
        }, rest.style),
        bordered: bordered,
        id: id,
        loading: loading,
        ref: inputRef,
        allowClear: true,
        notFoundContent: loading ? /*#__PURE__*/React.createElement(_Spin, {
          size: "small"
        }) : fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.notFoundContent,
        fetchData: function fetchData(keyWord) {
          keyWordsRef.current = keyWord;

          _fetchData(keyWord);
        },
        resetData: resetData,
        optionItemRender: function optionItemRender(item) {
          if (typeof item.label === 'string' && keyWordsRef.current) {
            return /*#__PURE__*/React.createElement(Highlight, {
              label: item.label,
              words: [keyWordsRef.current]
            });
          }

          return item.label;
        },
        placeholder: intl.getMessage('tableForm.selectPlaceholder', '请选择'),
        label: label
      }, fieldProps, {
        options: options
      }));
    };

    var _dom = renderDom();

    if (renderFormItem) {
      return renderFormItem(rest.text, _objectSpread(_objectSpread({
        mode: mode
      }, fieldProps), {}, {
        options: options
      }), _dom) || null;
    }

    return _dom;
  }

  return null;
};

export default /*#__PURE__*/React.forwardRef(FieldSelect);